export enum Gender {
    NotSpecified,
    Male,
    Female,
    NotDisclosed,
    Unknown
}
